import { render, staticRenderFns } from "./ArchivedUser.vue?vue&type=template&id=4f3ca9a6&scoped=true&lang=pug&"
import script from "./ArchivedUser.vue?vue&type=script&lang=js&"
export * from "./ArchivedUser.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedUser.vue?vue&type=style&index=0&id=4f3ca9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ca9a6",
  null
  
)

export default component.exports